import React, { useEffect, useState } from "react";
import { InformacionFuncionario } from "../../components/EtapasDeCalificacion/InformacionFuncionario";
import { ResumenEvaluaciones } from "../../components/PreCalificacion/ResumenEvaluaciones";
import { CalificacionFinal } from "../../components/PreCalificacion/CalificacionFinal";
import { useForm } from "../../hooks/useForm";
import {
  buscarParticipante,
  cargarCalificacionFinal,
  cargarProcesoActivo,
  enviarConformidad,
} from "../../utils/Datos";
import Swal from "sweetalert2";
import { selectUser } from "../../reducers/userSlice";
import { useSelector } from "react-redux";
import { PlaceholderTabla } from "../../components/Otros/Placeholder";

export const AceptarCalificacion = () => {
  const user = useSelector(selectUser);
  const [calificacionFinal, setcalificacionFinal] = useState(null);
  const [id_participant, setId_participant] = useState(null);
  const [apela, setapela] = useState(null);
  const [conforme, setconforme] = useState(null);
  const [valoresForm, handleInputChange, reset, updateValue, updateState] =
    useForm({
      id_qualifications: null,
      accordanceStatus: "CONFORME",
      appeal: {
        isAppealProcess: false,
      },
    });

  const [cargando, setcargando] = useState(false);

  //
  useEffect(() => {
    cargarProcesoActivo().then((datos) => {
      buscarParticipante(user.user.run, datos.id_process).then(
        (participant) => {
          setId_participant(participant.datos.id_participant);
          cargarCalificacionFinal(participant.datos.id_participant).then(
            (c) => {
              setcalificacionFinal(c);
              if (c.status) {
                updateValue("id_qualifications", c.datos.id_qualifications);
              }
            }
          );
        }
      );
    });
  }, []);

  const handleConformidad = (e) => {

    updateValue("accordanceStatus", e.target.value);
    if (e.target.value === "CONFORME") {
      setconforme(true);
      updateState([
        { name: "appeal", value: { isAppealProcess: false } },
        { name: "accordanceStatus", value: "CONFORME" },
      ]);
      //setapela(false);
    }else{
      setconforme(false);
      updateState([
        { name: "appeal", value: { isAppealProcess: false } },
        { name: "accordanceStatus", value: "DISCONFORME" },
      ]);
      
      //setapela(false);
    }
  };

  const handleApelacion = (e) => {
    updateState([
      { name: "appeal", value: { isAppealProcess: e.target.value } },
    ]);
    setapela(e.target.value);
    console.log(e.target.value)
  };

  const handleEnviar = () => {
    //enviar apelación
    
    console.log(valoresForm);
    if (conforme==null) {
      Swal.fire({
        icon:'warning',
        title:'Importante',
        text:'Debes seleccionar una opción para continuar.'
      })
    }else{
      if (!conforme && apela==null) {
        Swal.fire({
          icon:'warning',
          title:'Importante',
          text:'Has indicado que no estás conforme con tu calificación. Debes indicar si apelarás o no.'
        })
      }else{
        setcargando(true);
        
        enviarConformidad(valoresForm).then((r) => {
          setcargando(false);
          if (r.status === "BAD_REQUEST") {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: r.errors[0],
            });
          } else {
            console.log(r);
            Swal.fire(
              {
                icon: "success",
                title: "Listo",
                text: "Datos enviados correctamente",
              }
            ).then((okay) => {
              if (okay) {
                window.location.href = "/home";
              }
            });
          }
        });
      }
    }
    
    
  };

  return (
    <div
      className="content d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <div className="toolbar" id="kt_toolbar">
        <div
          id="kt_toolbar_container"
          className="container-fluid d-flex flex-stack"
        >
          <div
            data-kt-swapper="true"
            data-kt-swapper-mode="prepend"
            data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
            className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
          >
            <h1 className="d-flex text-dark fw-bolder fs-3 align-items-center my-1">
              {" "}
              VALIDAR EVALUACIÓN / PRECALIFICACIÓN{" "}
            </h1>
            <span className="h-20px border-gray-300 border-start mx-4" />
            <ul className="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
              <li className="breadcrumb-item text-muted">
                <a href="#" className="text-muted text-hover-primary">
                  Home
                </a>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-300 w-5px h-2px" />
              </li>
              <li className="breadcrumb-item text-dark">
                {" "}
                 INFORMACIÓN DEL/LA FUNCIONARIO/A
              </li>
            </ul>
          </div>
          <div className="d-flex align-items-center gap-2 gap-lg-3"></div>
        </div>
      </div>
      <div className="post d-flex flex-column-fluid" id="kt_post">
        <div className="container-xxl">
          <div className="row gy-5 g-xl-8">
            {id_participant != null ? (
              <InformacionFuncionario
                id_participant={id_participant}
                boton_historial={false}
              />
            ) : (
              <PlaceholderTabla />
            )}
            <div className="col-xl-12 ">
              <div className="card ">
                <div className="card-header ">
                  <h3 className="card-title align-items-start flex-column ">
                    <span className="card-label fw-bolder text-dark ">
                      VER EVALUACIONES Y PRECALIFICACIONES DEL
                      FUNCIONARIO
                    </span>
                  </h3>
                </div>
                <div className="card-body ">
                  {id_participant != null ? (
                    <ResumenEvaluaciones id_participant={id_participant} />
                  ) : (
                    <PlaceholderTabla />
                  )}
                  {id_participant != null ? (
                    <CalificacionFinal id_participant={id_participant} />
                  ) : (
                    <PlaceholderTabla />
                  )}
                  {calificacionFinal === null || !calificacionFinal.status ? (
                    <div className="row">
                      <div className="col-md-12">
                        <div className="alert alert-warning" role="alert">
                          <strong>Atención</strong>, no se ha encontrado una
                          calificación
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="row">
                      <div className="col-xl-12 mt-5">
                        <div className="row">
                          <div className="col-xl-6 mt-5">
                            <div className="notice d-flex  rounded border-info border border-dashed mb-12 p-6">
                              <div className="d-flex flex-stack flex-grow-1">
                                <div className="fw-bold">
                                  <h4 className="text-gray-900 fw-bolder mb-5">
                                    ¡Importante!
                                  </h4>
                                  <div className="form-check form-check-custom form-check-success form-check-solid mb-5">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="conforme"
                                      id="conforme-si"
                                      value="CONFORME"
                                      onChange={handleConformidad}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="conforme-si"
                                    >
                                      Estoy conforme con mi calificación
                                    </label>
                                  </div>
                                  <div className="form-check form-check-custom form-check-danger form-check-solid">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="conforme"
                                      id="conforme-no"
                                      value="DISCONFORME"
                                      onChange={handleConformidad}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="conforme-no"
                                    >
                                      No estoy de acuerdo con mi calificación
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {
                            conforme==false ? 
                            <div className="col-xl-6 mt-5">
                            <div className="notice d-flex  rounded border-danger border border-dashed mb-12 p-6">
                              <div className="d-flex flex-stack flex-grow-1">
                                <div className="fw-bold">
                                  <h4 className="text-gray-900 fw-bolder mb-5">
                                    ¡Importante!
                                  </h4>
                                  <div className="form-check form-check-custom form-check-success form-check-solid mb-5">
                                    <input
                                      className="form-check-input"
                                     
                                     
                                      type="radio"
                                      name="apelar"
                                      id="apelar"
                                      value={true}
                                      onChange={handleApelacion}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="apelar"
                                    >
                                      Apelaré
                                    </label>
                                  </div>
                                  <div className="form-check form-check-custom form-check-danger form-check-solid">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      
                                      name="apelar"
                                      id="no-apelar"
                                      value={false}
                                      onChange={handleApelacion}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="no-apelar"
                                    >
                                      No apelaré
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {apela == "true" ? (
                              <div className="alert alert-warning" role="alert">
                                <p>El(la) funcionario(a) que requiera apelar a su calificación, deberá solicitar la FICHA DE APELACIÓN al siguiente correo bfuentes@penalolen.cl  Profesional Bastián Fuentes de la Dirección de Gestión y Desarrollo de Personas.
                                Los plazos del proceso son:
                                <ul>
                                  <li>Apelación: 5 días hábiles, contados desde la fecha en la que fue notificado(a).		</li>
                                  <li>Envío de antecedentes a la Alcaldía: 3 días hábiles.	</li>
                                  <li>Resolución de Alcaldía: 15 días, contados desde su presentación.</li>
                                </ul>
                                </p>
              
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                            :<></>
                          }
                          
                        </div>
                      </div>
                      <div className="card-footer d-flex justify-content-end py-6 px-9">
                        <button
                          onClick={handleEnviar}
                          className="btn btn-success fw-bold"
                          disabled={cargando}
                        >
                          {!cargando ? ' enviar' : 'Generando documento...'}
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
